import React from "react";
import { Card, CardBody, Col } from "reactstrap";
import {
  getCompanyLogo,
  isValidURL,
  toArray,
} from "../../../../../helpers/common";
import NoLogo from "../../../../../assets/images/featured-job/no-logo.png";

const LeftSideContent = ({ details }) => {
  const companyDetails = details?.company || details?.data || details;
  const getWorkingDays = (string) => {
    const items = [];
    const list = toArray(string, "\n");
    list?.forEach((element) => items.push(toArray(element, "=>")));
    return items;
  };
  console.log("Leftside*", details);

  return (
    <React.Fragment>
      <Col lg={4}>
        <Card className="side-bar">
          <CardBody className="p-4">
            <div className="candidate-profile text-center">
              <img
  src={getCompanyLogo(companyDetails?.logo)}
  alt={companyDetails?.name || "Company Logo"}
  className="img-fluid rounded-3 comp-logo shadow-sm"
  style={{
    width: "120px",      // Increased width
    height: "120px",     // Increased height
    objectFit: "contain", // Prevents stretching/cropping
    padding: "4px",      // Gives breathing space
    backgroundColor: "#fff"
  }}
  onError={(e) => {
    e.target.onerror = null;
    e.target.src = NoLogo;
  }}
/>
              <h6 className="fs-18 mb-1 mt-4">{details.name}</h6>
              <p className="text-muted mb-4">
                Since {details?.data.establishmentYear}
              </p>
            </div>
          </CardBody>

          <CardBody className="candidate-profile-overview border-top p-2">
            <h6 className="fs-17 fw-semibold mb-3">Profile Overview</h6>
            <ul className="list-unstyled mb-0">
              {/* ✅ owner_name → ownerName */}
              {details.data?.ownerName && (
                <li>
                  <div className="d-flex">
                    <label className="text-dark">Company Name : </label>
                    <div>
                      <p className="text-muted mb-0">{details.data?.name}</p>
                    </div>
                  </div>
                </li>
              )}

              {/* ✅ total_employees → totalEmployees */}
              {details.data?.totalEmployees !== undefined && (
                <li>
                  <div className="d-flex">
                    <label className="text-dark">Total Employees :</label>
                    <div>
                      <p className="text-muted mb-0">
                        {details.data?.totalEmployees}
                      </p>
                    </div>
                  </div>
                </li>
              )}

              {/* ✅ companyAddress stays same */}
              {details.data?.companyAddress && (
                <li>
                  <div className="d-flex">
                    <label className="text-dark">Address :</label>
                    <div>
                      <p className="text-muted mb-0">
                        {details.data?.companyAddress}
                      </p>
                    </div>
                  </div>
                </li>
              )}

              {/* ✅ website_url → websiteUrl */}
              {details?.websiteUrl && (
                <li>
                  <div className="d-flex">
                    <label className="text-dark">Website</label>
                    <div>
                      <a
                        href={details?.websiteUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-muted text-break mb-0"
                      >
                        {details?.websiteUrl}
                      </a>
                    </div>
                  </div>
                </li>
              )}

              {details?.establishmentYear && (
                <li>
                  <div className="d-flex">
                    <label className="text-dark">Established</label>
                    <div>
                      <p className="text-muted mb-0">
                        {details?.establishmentYear}
                      </p>
                    </div>
                  </div>
                </li>
              )}
            </ul>
          </CardBody>

          {/* ✅ working_days → workingDays */}
          {/* {details.data?.workingDays ? (
            <CardBody className="p-4 border-top">
              <div className="ur-detail-wrap">
                <div className="ur-detail-wrap-header">
                  <h6 className="fs-17 fw-semibold mb-3">Working Days</h6>
                </div>
                <div className="ur-detail-wrap-body">
                  <ul className="working-days">
                    {getWorkingDays(details.data?.workingDays)?.map((e, index) => (
                      <li key={`working-days-` + index}>
                        {e[0]}
                        <span
                          className={`text-uppercase ${
                            e[1]?.toLowerCase() === "close"
                              ? "text-danger text-capitalize"
                              : ""
                          }`}
                        >
                          {e[1]}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </CardBody>
          ) : null} */}

          {/* ✅ map_location → mapLocation */}
          {details?.mapLocation && isValidURL(details?.mapLocation) ? (
            <CardBody className="p-4 border-top">
              <h6 className="fs-17 fw-semibold mb-4">Company Location</h6>
              <iframe
                src={details?.mapLocation}
                title="title"
                style={{ width: `100%`, height: `250` }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </CardBody>
          ) : null}
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default LeftSideContent;
